import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from '@paypalcorp/pp-react';
import BenefitCard from './BenefitCard';
import styles from './OverviewBenefits.module.less';

const OverviewBenefits = ({ ecmContent }) => {
  const { cards } = ecmContent;
  return (
    <Row className={styles.overview_benefits_container}>
      {cards.map((card, index) => (
        <Col key={index} xs={12} md={4}>
          <BenefitCard card={card} />
        </Col>
      ))}
    </Row>
  );
};

OverviewBenefits.propTypes = { ecmContent: PropTypes.object };
OverviewBenefits.defaultProps = { ecmContent: { cards: [] } };

export default OverviewBenefits;
